import {createReducer, on} from '@ngrx/store';
import {datevWizardCaseSelectionStateInitial} from './datev-wizard-case-selection.state.initial';
import {DatevWizardCaseSelectionActions} from './datev-wizard-case-selection.actions';

/**
 * DatevWizardCaseSelection Reducer
 *
 * Speichert den gewählten Export-Fall im State.
 */
export const datevWizardCaseSelectionReducer = createReducer(
  datevWizardCaseSelectionStateInitial,
  on(DatevWizardCaseSelectionActions.selectCase, (state, {caseType}) => ({
    ...state,
    selectedCase: caseType,
  })),
  on(DatevWizardCaseSelectionActions.resetCaseSelection, () => ({
    ...datevWizardCaseSelectionStateInitial,
  }))
);
